import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import { useBrandConfiguration } from '../../brands/context';
import { useConsent } from '../useConsent';
export const useHotjar = () => {
    const consent = useConsent();
    const { hotjarConfiguration } = useBrandConfiguration();
    useEffect(() => {
        if (consent && hotjarConfiguration) {
            const { id, version } = hotjarConfiguration;
            hotjar.initialize(id, version);
        }
    }, [consent]);
};
